import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight } from "lucide-react";
import useDocumentTitle from "../lib/useDocumentTitle";

export default function Blog() {
  useDocumentTitle("Blog", "Design & construction insights from HouseDesignWala™ — practical tips, guides and stories for Indian homeowners building their dream home.");
  const [posts, setPosts] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => { api.get("/blog").then(r => setPosts(r.data)); }, []);

  const filtered = posts.filter(p => p.title.toLowerCase().includes(search.toLowerCase()) || p.category.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <section className="bg-[#FEF3E2] py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#F7941D]">Blog</span>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold text-[#1a3c5e] mt-2">Design & Construction Insights</h1>
          <p className="mt-3 text-gray-700">Tips, guides, and stories for Indian homeowners.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search articles..."
          data-testid="blog-search"
          className="w-full max-w-md mx-auto block border border-[#1a3c5e]/15 rounded-xl px-4 py-3 mb-8 focus:outline-none focus:ring-2 focus:ring-[#F7941D]"
        />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map(p => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}>
              <article className="bg-white rounded-2xl overflow-hidden border border-[#1a3c5e]/10 hover-lift h-full">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="p-5">
                  <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded bg-[#FEF3E2] text-[#F7941D]">{p.category}</span>
                  <h3 className="font-display font-bold text-lg text-[#1a3c5e] mt-2 leading-tight line-clamp-2">{p.title}</h3>
                  <p className="text-sm text-gray-600 mt-2 line-clamp-2">{p.meta_desc}</p>
                  <div className="flex items-center gap-1 text-sm font-semibold text-[#F7941D] mt-3">
                    Read more <ArrowRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
        {filtered.length === 0 && <p className="text-center text-gray-500 py-12">No articles found.</p>}
      </div>
    </div>
  );
}
